module.exports = __webpack_public_path__ + "static/media/tg.6d8fe20f.svg";